export const throwNever = (value: never): never => {
  throw new Error(`Unexpected value: ${value}`);
};
